import usePrivateAxios from "@/common/api/usePrivateAxios"
import { CompanyEquipmentData, CompanyEquipmentResponse } from "@/features/privateCompanies/types/companyEquipments.type"
import { UseQueryOptions, UseQueryResult, useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

type UseCompanyEquipmentProps = {
  id: string
  options?: Partial<Omit<UseQueryOptions<CompanyEquipmentResponse, AxiosError, CompanyEquipmentData>, 'select' | 'queryKey' | 'queryFn'>>
}

type UseCompanyEquipmentType = ({ }: UseCompanyEquipmentProps) => UseQueryResult<CompanyEquipmentData, AxiosError>

const useCompanyEquipment: UseCompanyEquipmentType = ({ id, options }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyEquipmentResponse, AxiosError, CompanyEquipmentData>({
    queryKey: ['companyEquipment', id],
    queryFn: () => {
      return privateAxios.get(`/client/equipments/${id}`)
    },
    select: (data) => data?.data?.data,
    ...options,
  })
}

export default useCompanyEquipment
